import { connect } from 'react-redux'
import { compose } from 'redux'
import { reduxForm } from 'redux-form'
import { withStyles } from '@material-ui/core'

import { globalActions } from 'reduxModules/actions/GlobalActions'

import { CreateBusFormBase } from './CreateBusForm'

import { styles } from './styles'

const mapDispatchToProps = {
  onSubmit: globalActions.createBus
}

const enhance = compose(
  connect(null, mapDispatchToProps),
  reduxForm({
    form: 'createBus'
  }),
  withStyles(styles)
)

export const CreateBusForm = enhance(CreateBusFormBase)



// WEBPACK FOOTER //
// ./src/components/Buses/components/CreateBusForm/index.js